module.exports = __webpack_public_path__ + "img/flag_tr.121e8386.svg";